import React from 'react';

import MSelectDropdownIndicatorView from './MSelectDropdownIndicator.view';

type Props = Record<never, never>;

const MSelectDropdownIndicator: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return <MSelectDropdownIndicatorView>{props.children}</MSelectDropdownIndicatorView>;
};

MSelectDropdownIndicator.displayName = 'MSelectDropdownIndicator';
MSelectDropdownIndicator.defaultProps = {};

export default MSelectDropdownIndicator;
